<ng-container *ngIf="analysis$ | async as analysis; else default">
    <div class="header-container -analysis">
        <div class="details-analysis">
            <analysis-profile-card
                [profileManagement]="false"
                [profileId]="id"
                [profileName]="candidateName | uppercase"
            ></analysis-profile-card>
            <span>{{status}} - {{ analysis?.profile?.company }}</span>
        </div>
        <div class="actions-analysis">
            <span *ngIf="module === 'audit_module'">1/1</span>
            <span class="analysis-time">{{ timer.getSecondsLeft() * 1000 | date: 'mm:ss' }}</span>
            <div>
                <analysis-buttons [disabled]="disableFinish" [label]="'Finalizar'" [size]="'small'" [kind]="'primary'" (clicked)="openDialog(true)"></analysis-buttons>
            </div>
            <div>
                <button class="btn-close" [disabled]="disableClose"  (click)="closeAnalysis()"></button>
            </div>
        </div>
    </div>
</ng-container>
<ng-template #default>
    <div class="header-container -default">
        <div class="-left" [attr.data-test]="'divLeftMenu'">
            <button class="button-open-menu" aria-label="Abre menu lateral" type="button" (click)="openMenu(true)" [attr.data-test]="'btnMenu'">
                <span></span>
                <span></span>
                <span></span>
            </button>
            <div class="brand" [attr.data-test]="'divBrand'">
                <a [routerLink]="''" [attr.data-test]="'linkLogoAnalysis'">
                    <img src="assets/images/logo-analysis.svg" alt="unico | analysis" width="170">
                </a>
            </div>
        </div>
        <div class="search" [attr.data-test]="'divSearch'">
            <analysis-search [id]="'txtSearch'" [placeholder]="'Busque por nome ou CPF'"></analysis-search>
        </div>
    </div>
    <analysis-sidebar [active]="openedMenu" (showMenu)="openMenu($event)"></analysis-sidebar>
</ng-template>

